import anime from "animejs";

export default class BB_Responsive_Menu {
    constructor() {
        BB_Responsive_Menu.body_overlay = jQuery('#ob-body-overlay')
        BB_Responsive_Menu.body = jQuery('body')
        BB_Responsive_Menu.html = jQuery('html')

        BB_Responsive_Menu.header_btn = jQuery('.ob-responsive-menu-icon')
        BB_Responsive_Menu.sidebar = jQuery('.ob-responsive-menu-wrap')
        BB_Responsive_Menu.sidebar_close_btn = jQuery('.ob-responsive-menu-close-btn')

        BB_Responsive_Menu.nav = jQuery('.ob-responsive-menu-nav')

        BB_Responsive_Menu.init()
    }
    static init() {
        BB_Responsive_Menu.header_btn.on('click', BB_Responsive_Menu.sidebar_open)
        BB_Responsive_Menu.body_overlay.on('click', BB_Responsive_Menu.sidebar_close)
        BB_Responsive_Menu.sidebar_close_btn.on('click', BB_Responsive_Menu.sidebar_close)

        BB_Responsive_Menu.init_responsive_menu()
    }
    static sidebar_open() {
        BB_Responsive_Menu.body.addClass('ob-overlay-active')
        BB_Responsive_Menu.body.addClass('ob-responsive-menu-active')

        BB_Responsive_Menu.html.addClass('ob-scroll-lock')
    }
    static sidebar_close() {
        BB_Responsive_Menu.body.removeClass('ob-overlay-active')
        BB_Responsive_Menu.body.removeClass('ob-responsive-menu-active')

        BB_Responsive_Menu.html.removeClass('ob-scroll-lock')
    }
    static init_responsive_menu() {
        // BB_Responsive_Menu.menu_arrows()
    }
    static menu_arrows() {
        const menu_children = BB_Responsive_Menu.nav.find('.menu-item-has-children');
        const arrow_img = BB_Responsive_Menu.nav.find('.arrow-img-holder img');
        let link_height = BB_Responsive_Menu.nav.find('li > a')
        link_height = `${link_height.outerHeight()}px`;

        [...menu_children].forEach(el => {
            jQuery(el).prepend(`<div class="ob-responsive-dropdown" style="height:${link_height};">${arrow_img[0].outerHTML}</div>`)
        })

        jQuery('.ob-responsive-dropdown').on('click', BB_Responsive_Menu.dropdown)
    }
    static dropdown() {
        const this_li = jQuery(this).parent('li')
        
        this_li.toggleClass('ob-active')
    }
}

